import React from "react";
import PropTypes from "prop-types";
import { noop } from "lodash";
import { Input, Select, Textarea } from "../../../../components/base/index";
import { GENDER } from "../../../../variables/common.variable";

export default function LembarHarianForm2Eng(props) {
  const { onFormChange, form } = props;
  const choseone = [
    { label: "BB - Belum Berkembang", value: "belum_berkembang" },
    { label: "MB - Mulai Berkembang", value: "mulai_berkembang" },
    { label: "BSH - Berkembang Sesuai Harapan", value: "berkembang_sesuai_harapan" },
    { label: "BSB - Berkembang Sangat Baik", value: "berkembang_sangat_baik" },
  ];
  // const pengisian = [
  //   { label: 'Sikap', value: 'sikap'},
  //   { label: 'Kognitif', value: 'kognitif'},
  // ]
  return (
    <div className="lembar-harian2__custom-form">
      <div className="lembar-harian2__custom-form-row">
        <div className="lembar-harian2__custom-form-width__field">
          <div className="cetak-buku-induk__title">
            <p><b>Vocabulary Aspect (Perbendaharaan Kata)</b></p>
          </div>
          <Textarea
            type="text"
            name="obs_result_vocab"
            value={form.value.obs_result_vocab}
            label="Hasil Observasi "
            onChange={onFormChange}
            rows={5}
              style={{backgroundColor: 'yellow'}}

          />
        </div>
        <div className="lembar-harian2__custom-form-width__field">
          <div className="cetak-buku-induk__title">
            <p><b>Speaking Aspect (Berbicara)</b></p>
          </div>
          <Textarea
            type="text"
            name="obs_result_speaking"
            value={form.value.obs_result_speaking}
            label="Hasil Observasi "
            onChange={onFormChange}
            rows={5}
              style={{backgroundColor: 'yellow'}}

          />
        </div>
      </div>
      
      <br/>
      <div className="lembar-harian2__custom-form-row">
        <div className="lembar-harian2__custom-form-width__field">
          <div className="cetak-buku-induk__title">
            <p><b>Listening Aspect (Mendengarkan)</b></p>
          </div>
          <Textarea
            type="text"
            name="obs_result_listening"
            value={form.value.obs_result_listening}
            label="Hasil Observasi "
            onChange={onFormChange}
            rows={5}
              style={{backgroundColor: 'yellow'}}

          />
        </div>
        <div className="lembar-harian2__custom-form-width__field">
          <div className="cetak-buku-induk__title">
            <p><b>Singing Aspect (Bernyanyi)</b></p>
          </div>
          <Textarea
            type="text"
            name="obs_result_singing"
            value={form.value.obs_result_singing}
            label="Hasil Observasi "
            onChange={onFormChange}
            rows={5}
              style={{backgroundColor: 'yellow'}}

          />
        </div>
      </div>

      
      {/* <div className="lembar-harian2__title">
        <h1>Catatan Guru</h1>
      </div>
      <Textarea
        type="text"
        name="teacher_notes"
        value={form.value.teacher_notes}
        onChange={onFormChange}
      /> */}
    </div>
  );
}
LembarHarianForm2Eng.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
LembarHarianForm2Eng.defaultProps = {
  onFormChange: noop,
};
